import { SignatureType } from '@ui/shared/model';

export enum DigitalContractWizardSteps {
  PERSONAL_INFORMATION = 'personalInformation',
  VIEWING = 'viewing',
  QES = 'qes',
  QES_MISSING_TERMS_AND_CONDITIONS = 'qesMissingTermsAndConditions',
  ID_VERIFICATION = 'idVerification',
  CODE_VERIFICATION = 'codeVerification',
  SIGNING = 'signing'
}

export const SignContractStepsRoutes = [
  {
    path: DigitalContractWizardSteps.PERSONAL_INFORMATION,
    loadComponent: () =>
      import('./components/contract-personal-information/contract-personal-information.component').then(
        m => m.ContractPersonalInformationComponent
      ),
    title: 'digital_contract.wizard_tenant_sign.personal_information_title_l'
  },
  {
    path: DigitalContractWizardSteps.VIEWING,
    loadComponent: () =>
      import('./components/contract-viewing/contract-viewing.component').then(
        m => m.ContractViewingComponent
      ),
    title: 'digital_contract.wizard_tenant_sign.viewing_title_l'
  },
  {
    path: DigitalContractWizardSteps.ID_VERIFICATION,
    loadComponent: () =>
      import('./components/contract-id-verification/contract-id-verification.component').then(
        m => m.ContractIdVerificationComponent
      ),
    signatureType: SignatureType.AES_MAIL,
    title: 'digital_contract.wizard_tenant_sign.id_verification_title_l'
  },
  {
    path: DigitalContractWizardSteps.CODE_VERIFICATION,
    loadComponent: () =>
      import('./components/contract-code-verification/contract-code-verification.component').then(
        m => m.ContractCodeVerificationComponent
      ),
    signatureType: SignatureType.AES_MAIL,
    title: 'digital_contract.wizard_tenant_sign.code_verification_title_l'
  },
  {
    path: DigitalContractWizardSteps.SIGNING,
    loadComponent: () =>
      import('./components/contract-signing/contract-signing.component').then(
        m => m.ContractSigningComponent
      ),
    title: 'digital_contract.wizard_tenant_sign.signing_title_l'
  }
];
